<template>
  <v-dialog
		v-model="dialog"
		persistent
		width="900"
	>
		<v-card>
			<!-- Cabecera del formulario -->
			<v-card-title class="headline">
				<v-icon>visibility</v-icon>  Documento adjunto
				<v-spacer></v-spacer>
        <v-btn
          flat
          icon
          title="Ver en otra ventana"
          @click="openNewWindow()"
        >
          <v-icon>fullscreen</v-icon>
        </v-btn>
				<v-btn icon @click.native="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
            <embed :src="api_backend[0]+documento.url_documento" type="application/pdf" v-if="tipo_documento === 'pdf'" width="100%" height="700px">
						<img :src="api_backend[0]+documento.url_documento" v-if="tipo_documento !== 'pdf'" width="100%">
          </v-flex>
        </v-layout>
      </v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	// Variables iniciales
	data () {
		return {
			dialog: false,
			loading: false,
      documento: {
				url_documento: ''
			},
			tipo_documento: '',
			api_backend: ''
		}
	},
	mounted () {
		this.$bus.$on('openDialogVerDocumento', item => {
			this.tipo_documento = this.obtenerTipo(item.url_documento)
			this.documento = item
			this.api_backend = process.env.API_URL.split('api/')
			this.dialog = true
		})
	},
	methods: {
		close () {
			this.loading = false
			this.dialog = false
		},
    openNewWindow () {
      window.open(this.api_backend[0]+this.documento.url_documento)
    },
		obtenerTipo (url) {
			const archivo = url.split('.')
			return archivo[1]
		}
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/dialogs/VerDocumento.vue